export enum TimeParameter {
    OneDay = 24 * 60 * 60 * 1000,
    OneWeek = 7 * 24 * 60 * 60 * 1000,
    OneMonth = 30 * 24 * 60 * 60 * 1000,
}

